export default "__VITE_ASSET__C$mAHnm2__"